import { render, staticRenderFns } from "./TrendUpIcon.vue?vue&type=template&id=2f40b6fb&scoped=true&"
import script from "./TrendUpIcon.vue?vue&type=script&lang=js&"
export * from "./TrendUpIcon.vue?vue&type=script&lang=js&"
import style0 from "./TrendUpIcon.vue?vue&type=style&index=0&id=2f40b6fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f40b6fb",
  null
  
)

export default component.exports